import { render } from "./Popular.vue?vue&type=template&id=665e562e"
import script from "./Popular.vue?vue&type=script&lang=js"
export * from "./Popular.vue?vue&type=script&lang=js"

import "./Popular.vue?vue&type=style&index=0&id=665e562e&lang=scss"

import exportComponent from "C:\\Users\\User\\Desktop\\Vue CLI\\new-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__